export default __webpack_public_path__ + "static/media/Tasset of the Warded Brute.7f6c1450.jpg";